import { render, staticRenderFns } from "./DiseaseSelectForm.vue?vue&type=template&id=d6cea97c&scoped=true&"
import script from "./DiseaseSelectForm.vue?vue&type=script&lang=js&"
export * from "./DiseaseSelectForm.vue?vue&type=script&lang=js&"
import style0 from "./DiseaseSelectForm.vue?vue&type=style&index=0&id=d6cea97c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6cea97c",
  null
  
)

export default component.exports